import * as Immutable from 'immutable';
import {createReducer} from 'redux-store';
import actionTypes from '../constants/course-edit-admins-action-types';

import type {List, Map} from 'immutable';

export type CourseEditAdminsStore = {
    course: Map<unknown, unknown>;
    users: Map<unknown, unknown>;
    organizations: Map<unknown, unknown>;
    courseContributorDefaults: List<unknown>;
};

const initialState = () => {
    return {
        course: Immutable.Map(),
        users: Immutable.Map({
            // search results
            contributor: Immutable.List(),
            monitor: Immutable.List(),
            owner: Immutable.List(),
            viewer: Immutable.List(),
        }),
        organizations: Immutable.Map({
            // currently we're only allowing orgs for viewers
            viewer: Immutable.List(),
        }),
        courseContributorDefaults: Immutable.List(),
    };
};

const actionsMap = {
    [actionTypes.GET_COURSE_SUCCESS]: (state, action) => {
        return {
            course: action.data,
        };
    },

    [actionTypes.DISPOSE]: () => {
        return initialState();
    },

    [actionTypes.USERS_RESET]: (state, action) => {
        let {users} = state;
        users = users.set(action.key, Immutable.List());

        return {
            users,
        };
    },

    [actionTypes.ORGANIZATIONS_RESET]: (state, action) => {
        let {organizations} = state;
        organizations = organizations.set(action.key, Immutable.List());

        return {
            organizations,
        };
    },

    [actionTypes.USERS_SUCCESS]: (state, action) => {
        let {users} = state;
        users = users.set(action.key, action.data);

        return {
            users,
        };
    },

    [actionTypes.COURSE_CONTRIBUTOR_DEFAULTS_SUCCESS]: (state, action) => {
        return {
            courseContributorDefaults: action.data,
        };
    },

    [actionTypes.SEARCH_ORGANIZATIONS_SUCCESS]: (state, action) => {
        let {organizations} = state;
        organizations = organizations.set(action.key, action.data);

        return {
            organizations,
        };
    },
};

export default createReducer<CourseEditAdminsStore>(initialState(), actionsMap);
